import { render, staticRenderFns } from "./ProductGroupForm.vue?vue&type=template&id=04242dac&scoped=true&"
import script from "./ProductGroupForm.vue?vue&type=script&lang=ts&"
export * from "./ProductGroupForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04242dac",
  null
  
)

export default component.exports